/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Program.Performance.Domain.vue?vue&type=template&id=3da0d117"
import script from "./Program.Performance.Domain.vue?vue&type=script&lang=js"
export * from "./Program.Performance.Domain.vue?vue&type=script&lang=js"
import style0 from "./Program.Performance.Domain.vue?vue&type=style&index=0&id=3da0d117&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports